// extracted by mini-css-extract-plugin
module.exports = {"categoryTags":"styles_categoryTags__vn_s_","header":"styles_header__6rvOf","footer":"styles_footer__xdKJk","filtersButton":"styles_filtersButton__sTmdI"};